import gql from 'graphql-tag';

export const checkIfChannelExistsQuery = gql`
  query checkIfChannelExistsQuery($id: String!) {
    checkIfChannelExists(id: $id)
  }
`;
